module.exports = __webpack_public_path__ + "img/raw_data.017c6fd2.svg";